/* TF · Worn By — marquee horizontal infinito (auto + hover-pausa + arrastre + loop sin saltos)
 * + video 9:16 con carga/reproducción diferida por visibilidad (IntersectionObserver). */
(function () {
  'use strict';
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(section) {
    var vp = section.querySelector('[data-tf-worn-viewport]');
    var track = section.querySelector('[data-tf-worn-track]');
    if (!vp || !track || track.__wornInit) return;
    track.__wornInit = true;

    var originals = Array.prototype.slice.call(track.children);
    var n = originals.length;
    if (!n) return;

    // Clonar el set 2 veces (3 sets) para un loop continuo sin bordes visibles.
    for (var k = 0; k < 2; k++) {
      originals.forEach(function (c) {
        var cl = c.cloneNode(true);
        cl.setAttribute('aria-hidden', 'true');
        cl.classList.add('is-clone');
        cl.querySelectorAll('a').forEach(function (a) { a.tabIndex = -1; });
        track.appendChild(cl);
      });
    }

    var dir = section.getAttribute('data-direction') === 'ltr' ? -1 : 1;
    var speed = parseFloat(section.getAttribute('data-speed'));
    if (isNaN(speed)) speed = 40;

    /* ---- Video: cargar y reproducir SOLO lo visible (posters primero) ---- */
    function loadVideo(v) {
      if (v.__loaded) return; v.__loaded = true;
      v.querySelectorAll('source[data-src]').forEach(function (so) {
        if (!so.getAttribute('src')) so.setAttribute('src', so.getAttribute('data-src'));
      });
      v.load();
    }
    if (!reduce && 'IntersectionObserver' in window) {
      var vids = track.querySelectorAll('[data-tf-worn-video]');
      if (vids.length) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            var v = en.target;
            if (en.isIntersecting) {
              loadVideo(v);
              var p = v.play();
              if (p && p.then) p.then(function () { v.classList.add('is-playing'); }).catch(function () {});
              else v.classList.add('is-playing');
            } else {
              v.pause();
              v.classList.remove('is-playing');
            }
          });
        }, { root: vp, rootMargin: '0px 200px', threshold: 0.2 });
        vids.forEach(function (v) { io.observe(v); });
      }
    }

    var period = 0;
    function measure() {
      period = track.children[n].offsetLeft - track.children[0].offsetLeft;
      if (dir < 0 && vp.scrollLeft < 1 && period > 0) vp.scrollLeft = period;
    }

    var hovering = false, down = false, startX = 0, prevX = 0, moved = false;

    vp.addEventListener('pointerenter', function () { hovering = true; });
    vp.addEventListener('pointerleave', function () { hovering = false; });
    vp.addEventListener('pointerdown', function (e) {
      down = true; moved = false; startX = e.clientX; prevX = e.clientX;
      vp.classList.add('is-dragging');
      if (e.pointerType === 'mouse') { try { vp.setPointerCapture(e.pointerId); } catch (_) {} }
    });
    vp.addEventListener('pointermove', function (e) {
      if (!down) return;
      if (e.pointerType === 'mouse') { vp.scrollLeft -= (e.clientX - prevX); }
      prevX = e.clientX;
      if (Math.abs(e.clientX - startX) > 4) moved = true;
    });
    function up() { down = false; vp.classList.remove('is-dragging'); }
    vp.addEventListener('pointerup', up);
    vp.addEventListener('pointercancel', up);
    vp.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);

    addEventListener('resize', measure, { passive: true });
    measure();
    setTimeout(measure, 60);
    if (document.readyState !== 'complete') addEventListener('load', measure, { once: true });

    var last = performance.now();
    function frame(now) {
      var dt = Math.min(0.05, (now - last) / 1000); last = now;
      if (period > 0) {
        if (!reduce && !hovering && !down && speed > 0) { vp.scrollLeft += dir * speed * dt; }
        if (vp.scrollLeft >= period) vp.scrollLeft -= period;
        else if (vp.scrollLeft <= 0) vp.scrollLeft += period;
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  function boot(root) {
    (root || document).querySelectorAll('[data-tf-worn]').forEach(init);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', function () { boot(); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
